<template>
  <div class="inline-editor">
    <div class="editor-container">
      <md-field class="label-field" :class="{'md-invalid': false}" :md-counter="maxLength > 0">
        <md-input
          ref="labelInput"
          aria-label="Input"
          data-testid="label-input"
          :value="state.updatedValue"
          class="label-input"
          :placeholder="placeholder"
          :maxlength="maxLength"
          @input="update"
          @keyup.enter="apply"
          @keyup.esc="cancel"
        />
        <div class="top-right-absolute">
          <md-button
            :md-ripple="false"
            class="md-icon-button md-dense"
            tabindex="-1"
            aria-label="Apply Button"
            data-testid="apply-button"
            @click="apply"
          >
            <md-icon>done</md-icon>
          </md-button>
        </div>
      </md-field>
    </div>
  </div>
</template>

<script>
export default {
  name: 'inline-editor',
  props: {
    value: {
      type: String,
      default: null
    },
    placeholder: {
      type: String,
      default: null
    },
    maxLength: {
      type: Number,
      default: null
    },
  },
  data() {
    return {
      state: {
        updatedValue: this.value,
      }
    }
  },
  mounted() {
    if (this.$refs.labelInput) {
      this.$refs.labelInput.$el.focus();
    }
  },
  methods: {
    update(value) {
      this.state.updatedValue = value;
    },
    apply() {
      this.$emit('apply', this.state.updatedValue);
    },
    cancel() {
      this.$emit('cancel');
    }
  }
}
</script>

<style scoped>
.editor-container {
  margin: 2px 20px;
}

.label-field {
  min-height: unset;
  margin: 0;
  padding: 0;
}

.top-right-absolute {
  position: absolute;
  display: flex;
  align-items: flex-end;
  top: 0px;
  right: 0px;
}

.label-field .md-icon-button {
  margin: 0;
}

.label-input {
  padding-right: 40px;
}
</style>